/**
 * 三包管理--》三包装配-异常登记
*/

export default {
    // https://lqms.lqfast.com/#/home/details?tasknos=202506171534177336957
    // https://imagecdn.ymm56.com/ymmfile/static/resource/4c4b0f37-3571-4c92-9b3b-ae1ff7946e9c 对应效果
    sanbao_showAbnormalReport_switch: ["79027"], // 202506171534177336957, 在三包管理—异常登记里的其他异常类型细分里，添加一个“异常报备”

    // sanbao_other_exception_type_90782: ["90782"], // 收敛历史权限
    sanbao_showShuanZeReport_switch: ["90782"], // 收敛历史权限
    sanbao_showChaoQuFee_switch: ["82635", "98321"], // 202508021758542708380 定制，异常登记，新增超区费
    // 202509081133333203648 三包管理-签收，定制可以上传20张图片
    sanbao_maxUploadImgNum_switch: ["90030"]

}